
const state = {
  couponId: '',
  couponName: '选择优惠券',
  couponValue: 0,
  orderPrice: '',
  showPopup: false,
  selectTime: null,
  selectArea: null,
  selectField: null,
  selectRole: null,
  addInfo: null,
  purpose: '',
  productId: ''
}
const getters = {
  getCouponId: state => state.couponId,
  getCouponName: state => state.couponName,
  getCouponValue: state => state.couponValue,
  getOrderPrice: state => state.orderPrice,
  getShowPopup: state => state.showPopup,
  getSelectTime: state => state.selectTime,
  getSelectArea: state => state.selectArea,
  getSelectField: state => state.selectField,
  getSelectRole: state => state.selectRole,
  getAddInfo: state => state.addInfo,
  getPurpose: state => state.purpose,
  getProductId: state => state.productId
}

const mutations = {
  setCouponId (state, couponId) {
    state.couponId = couponId
  },
  setCouponName (state, couponName) {
    state.couponName = couponName
  },
  setOrderPrice (state, orderPrice) {
    state.orderPrice = orderPrice
  },
  setCouponValue (state, couponValue) {
    state.couponValue = couponValue
  },
  setShowPopup (state, showPopup) {
    state.showPopup = showPopup
  },
  setSelectTime (state, selectTime) {
    state.selectTime = selectTime
  },
  setSelectArea (state, selectArea) {
    state.selectArea = selectArea
  },
  setSelectField (state, selectField) {
    state.selectField = selectField
  },
  setSelectRole (state, selectRole) {
    state.selectRole = selectRole
  },
  setAddInfo (state, addInfo) {
    state.addInfo = addInfo
  },
  setPurpose (state, purpose) {
    state.purpose = purpose
  },
  setProductId (state, productId) {
    state.productId = productId
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}

export {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/order.js